<template>
  <div class="record-list-container">
    <!-- 搜索和操作区域 -->
    <div class="search-bar">
      <el-input v-model="searchForm.shop_name" placeholder="请输入商品名称" clearable size="large"
        style="width: 300px; margin-right: 15px" @keyup.enter="handleSearch">
        <template #prefix>
          <el-icon>
            <Search />
          </el-icon>
        </template>
      </el-input>

      <el-button type="primary" size="large" @click="handleSearch">
        <el-icon>
          <Search />
        </el-icon>
        搜索
      </el-button>

      <el-button type="success" size="large" @click="openAddDialog" style="float: right">
        <el-icon>
          <Plus />
        </el-icon>
        新增商品
      </el-button>

      <el-button type="warning" size="large" @click="openBatchImportDialog" style="margin-left: 10px; float: right">
        <el-icon>
          <Upload />
        </el-icon>
        批量导入
      </el-button>
    </div>

    <!-- 商品记录列表 -->
    <el-table :data="recordList" stripe style="width: 100%; margin-top: 20px" v-loading="loading">
      <el-table-column prop="shop_name" label="商品名称" width="200" />
      <el-table-column prop="shop_desc" label="商品描述" width="300" />
      <el-table-column label="商品链接" width="200">
        <template #default="{ row }">
          <el-link type="primary" :href="row.shop_url" target="_blank" v-if="row.shop_url">查看链接</el-link>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="notes" label="备注" width="150" />
      <el-table-column prop="create_time" label="创建时间" width="180" />
      <el-table-column prop="update_time" label="更新时间" width="180" />

      <el-table-column label="操作" width="180" fixed="right">
        <template #default="scope">
          <el-button type="primary" size="small" @click="openEditDialog(scope.row)">
            <el-icon>
              <Edit />
            </el-icon>
            编辑
          </el-button>
          <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">
            <el-icon>
              <Delete />
            </el-icon>
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <div class="pagination-container">
      <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
        :total="pagination.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper"
        @size-change="fetchRecordList" @current-change="fetchRecordList" />
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="700px" :close-on-click-modal="false">
      <el-form ref="recordForm" :model="recordForm" label-width="120px" :rules="formRules">
        <el-form-item label="商品名称" prop="shop_name">
          <el-input v-model="recordForm.shop_name" placeholder="请输入商品名称" size="large" />
        </el-form-item>

        <el-form-item label="商品描述">
          <el-input v-model="recordForm.shop_desc" placeholder="请输入商品描述" type="textarea" :rows="3" />
        </el-form-item>

        <el-form-item label="商品链接">
          <el-input v-model="recordForm.shop_url" placeholder="请输入商品链接" size="large">
          </el-input>
        </el-form-item>

        <el-form-item label="备注信息">
          <el-input v-model="recordForm.notes" placeholder="请输入备注信息" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitRecordForm">确认</el-button>
      </template>
    </el-dialog>

    <!-- 批量导入对话框 -->
    <el-dialog v-model="importDialogVisible" title="批量导入商品记录" width="500px" :close-on-click-modal="false">
      <el-tabs v-model="importActiveTab">
        <el-tab-pane label="Excel导入" name="excel">
          <el-upload class="upload-demo" drag ref="excelUploadRef" action="" :auto-upload="false"
            :on-change="handleExcelChange" accept=".xlsx,.xls" :limit="1">
            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
            <div class="el-upload__text">将Excel文件拖到此处，或<em>点击上传</em></div>
            <template #tip>
              <div class="el-upload__tip">请上传Excel文件，支持.xlsx和.xls格式</div>
              <div style="margin-top: 20px; text-align: center;">
                <el-button type="text" @click="downloadTemplate">
                  <el-icon>
                    <Download />
                  </el-icon>
                  下载Excel模板
                </el-button>
              </div>
            </template>
          </el-upload>
        </el-tab-pane>
      </el-tabs>

      <template #footer>
        <el-button @click="importDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitBatchImport">确认导入</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import * as XLSX from 'xlsx'
import {
  Search, Plus, Edit, Delete, UploadFilled, Download
} from '@element-plus/icons-vue'

export default {
  name: 'MountingRecordView',
  components: { Search, Plus, Edit, Delete, UploadFilled, Download },
  props: {
    shopId: {
      type: Number,
      required: true
    },
    storeId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      importDialogVisible: false,
      importActiveTab: 'excel',
      importFile: null,
      importData: [],
      dialogTitle: '新增商品记录',
      isEditMode: false,
      searchForm: {
        shop_name: ''
      },
      recordForm: {
        id: null,
        shop_name: '',
        shop_desc: '',
        shop_url: '',
        notes: '',
        shop_id: this.shopId,
        store_id: this.storeId
      },
      formRules: {
        shop_name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ]
      },
      recordList: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  mounted() {
    this.fetchRecordList();
  },
  methods: {
    // 获取记录列表
    async fetchRecordList() {
      this.loading = true;
      try {
        const params = {
          action: this.searchForm.shop_name ? 'search' : 'list',
          store_id: this.storeId,
          shop_id: this.shopId,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        };

        if (this.searchForm.shop_name) {
          params.shop_name = this.searchForm.shop_name;
        }

        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/shop_mounting_record.php`,
          params
        );

        if (data.data) {
          this.recordList = data.data;
          this.pagination.total = data.pagination?.total || data.data.length;
        }
      } catch (error) {
        this.$message.error('获取商品记录失败');
        console.error('获取商品记录错误:', error);
      } finally {
        this.loading = false;
      }
    },
    // 处理搜索
    handleSearch() {
      this.pagination.page = 1;
      this.fetchRecordList();
    },
    // 打开新增对话框
    openAddDialog() {
      this.dialogTitle = '新增商品记录';
      this.isEditMode = false;
      this.recordForm = {
        id: null,
        shop_name: '',
        shop_desc: '',
        shop_url: '',
        notes: '',
        shop_id: this.shopId,
        store_id: this.storeId
      };
      this.dialogVisible = true;
    },
    // 打开编辑对话框
    openEditDialog(row) {
      this.dialogTitle = '编辑商品记录';
      this.isEditMode = true;
      this.recordForm = {
        id: row.id,
        shop_name: row.shop_name,
        shop_desc: row.shop_desc,
        shop_url: row.shop_url,
        notes: row.notes,
        shop_id: this.shopId,
        store_id: this.storeId
      };
      this.dialogVisible = true;
    },
    // 提交表单（新增/编辑）
    submitRecordForm() {
      this.$refs.recordForm.validate(async (valid) => {
        if (valid) {
          try {
            const action = this.isEditMode ? 'update' : 'add';
            const { data } = await axios.post(
              `${config.BASE_URL}/shop/api/shop_mounting_record.php`,
              {
                action,
                ...this.recordForm
              }
            );

            if (data.success) {
              this.$message.success(this.isEditMode ? '更新成功' : '添加成功');
              this.dialogVisible = false;
              this.fetchRecordList();
            } else {
              this.$message.error(data.error || '操作失败');
            }
          } catch (error) {
            const errorMsg = error.response?.data?.error || error.message || '操作失败';
            this.$message.error(`操作失败: ${errorMsg}`);
            console.error('表单提交错误:', error);
          }
        }
      });
    },
    // 删除记录
    async handleDelete(id) {
      this.$confirm('确定要删除该商品记录吗？', '警告', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data } = await axios.post(
            `${config.BASE_URL}/shop/api/shop_mounting_record.php`,
            {
              action: 'delete',
              id: id,
              store_id: this.storeId
            }
          );

          if (data.success) {
            this.$message.success('删除成功');
            this.fetchRecordList();
          } else {
            this.$message.error(data.error || '删除失败');
          }
        } catch (error) {
          const errorMsg = error.response?.data?.error || error.message || '删除失败';
          this.$message.error(`删除失败: ${errorMsg}`);
          console.error('删除错误:', error);
        }
      }).catch(() => { });
    },
    // 打开批量导入对话框
    openBatchImportDialog() {
      this.importDialogVisible = true;
      this.importActiveTab = 'excel';
      this.importFile = null;
      this.importData = [];
      if (this.$refs.excelUploadRef) {
        this.$refs.excelUploadRef.clearFiles();
      }
    },
    // 处理Excel文件变化
    handleExcelChange(file) {
      this.importFile = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet);

        this.importData = jsonData.map(item => ({
          shop_id: this.shopId,
          shop_name: item['商品名称'] || item['shop_name'] || '',
          shop_desc: item['商品描述'] || item['shop_desc'] || '',
          shop_url: item['商品链接'] || item['shop_url'] || '',
          notes: item['备注'] || item['notes'] || ''
        })).filter(item => item.shop_name);
      };
      reader.readAsArrayBuffer(file.raw);
    },
    // 下载Excel模板
    downloadTemplate() {
      // 创建工作簿
      const wb = XLSX.utils.book_new();

      // 创建数据
      const templateData = [
        {
          '商品名称': '示例商品1',
          '商品描述': '这是示例商品1的描述',
          '商品链接': 'https://example.com/product1',
          '备注': '示例备注1'
        },
        {
          '商品名称': '示例商品2',
          '商品描述': '这是示例商品2的描述',
          '商品链接': 'https://example.com/product2',
          '备注': '示例备注2'
        }
      ];

      // 创建工作表
      const ws = XLSX.utils.json_to_sheet(templateData);

      // 设置列宽
      ws['!cols'] = [
        { wch: 20 },  // 商品名称
        { wch: 30 },  // 商品描述
        { wch: 30 },  // 商品链接
        { wch: 20 }   // 备注
      ];

      // 添加工作表到工作簿
      XLSX.utils.book_append_sheet(wb, ws, "商品数据");

      // 生成Excel文件并下载
      XLSX.writeFile(wb, '商品批量导入模板.xlsx');
    },
    // 提交批量导入
    async submitBatchImport() {
      if (this.importData.length === 0) {
        this.$message.warning('没有可导入的数据');
        return;
      }

      try {
        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/shop_mounting_record.php`,
          {
            action: 'batch_import',
            store_id: this.storeId,
            shop_id: this.shopId,
            batch: this.importData
          }
        );

        if (data.success) {
          this.$message.success(`成功导入 ${data.imported_count} 条记录`);
          this.importDialogVisible = false;
          this.fetchRecordList();
        } else {
          this.$message.error(data.error || '导入失败');
        }
      } catch (error) {
        this.$message.error('导入失败: ' + (error.response?.data?.error || error.message));
        console.error('导入错误:', error);
      }
    }
  }
}
</script>

<style scoped>
.record-list-container {
  padding: 20px;

  .search-bar {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 16px;
    background: #f8fafc;
    border-radius: 8px;
  }

  .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }

  /* 操作按钮样式 */
  .el-button {
    display: inline-flex;
    align-items: center;

    .el-icon {
      margin-right: 5px;
    }
  }
}
</style>